module.exports = __webpack_public_path__ + "616b4b597dc919b48de85356fb7815e6.ttf";